import React, { Fragment } from "react";
import { Combobox, Transition } from "@headlessui/react";
import { FiCheck, FiChevronDown } from "react-icons/fi";
import { useState } from "react";
import { usePopper } from "react-popper";
import { debounce } from "../../../../Utils/utils";
import Loader from "../Loader";

function Combo({ onChange = () => {}, icon, className = "", placeholder = "", renderItem, selected = {}, onSelect = () => {}, options = [{ label: "Select an option", value: "None" }], label = "", loading = false }) {
	const [query, setQuery] = useState("");

	const debouncedSearch = debounce((nextQuery) => {
		setQuery(nextQuery);
		onChange(nextQuery);
	});

	const handleChange = (query) => {
		debouncedSearch(query);
	};

	const handleSelect = (option) => {
		onSelect(option);
	};

	//Popper stuff
	const [PopRef, setPopRef] = useState(null);
	const [PopElem, setPopElem] = useState(null);
	const { styles, attributes } = usePopper(PopRef, PopElem, {
		placement: "bottom-start",
	});

	return (
		<Combobox as="div" value={selected} onChange={handleSelect} className={`combobox ${className}`}>
			{label && <Combobox.Label className="block mb-2">{label}</Combobox.Label>}
			<div className="relative" ref={setPopRef}>
				<Combobox.Button className="flex items-center justify-between w-full input cursor-pointer">
					<span className={`truncate ${!selected?.label ? "text-secondary" : ""}`}>
						{selected?.label || placeholder}
					</span>
					<div className="flex items-center gap-1">
						{icon && <span className="flex-center">{icon}</span>}
						<FiChevronDown className="text-xs text-secondary" />
					</div>
				</Combobox.Button>
			</div>
			<Transition
				ref={setPopElem}
				style={styles.popper}
				{...attributes.popper}
				className="z-10 w-full"
				afterLeave={() => setQuery("")}
			>
				<Combobox.Options className="options">
					<div className="p-2 border-b border-surface bg-white">
						<input
							autoFocus
							className="w-full px-2 py-1 text-sm border rounded-md outline-none border-surface focus:ring-1 focus:ring-primary"
							placeholder="Search"
							onChange={(event) => handleChange(event.target.value)}
						/>
					</div>
					{options.length === 0 ? (
						<div className="relative p-3 text-xs text-gray-700 cursor-default select-none">
							No results{query ? (
								<>
									{" "}
									for <b>"{query}"</b>
								</>
							) : null}
						</div>
					) : (
						options.map((option, i) => (
							<Combobox.Option key={i} value={option} as={Fragment} className="item">
								{({ active, selected }) =>
									renderItem ? (
										renderItem(option, active, selected)
									) : (
										<li className={`${active ? "bg-light" : "bg-white"}`}>
											{option.label}
											{selected && <FiCheck className="ml-2" />}
										</li>
									)
								}
							</Combobox.Option>
						))
					)}
					<Loader loading={loading} />
				</Combobox.Options>
			</Transition>
		</Combobox>
	);
}

export default Combo;
